import type { PropsWithChildren, ReactNode } from 'react';

export function Page({
  title,
  description,
  actions,
  children,
}: PropsWithChildren<{ title: string; description?: string; actions?: ReactNode }>) {
  return (
    <section>
      <header className="page-head">
        <div>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        {actions}
      </header>
      {children}
    </section>
  );
}

export function Card({ children, className = '' }: PropsWithChildren<{ className?: string }>) {
  return <div className={`card ${className}`}>{children}</div>;
}

export function State({
  loading,
  error,
  empty,
  children,
}: PropsWithChildren<{ loading?: boolean; error?: unknown; empty?: boolean }>) {
  if (loading)
    return (
      <div className="state" role="status">
        Loading…
      </div>
    );
  if (error)
    return (
      <div className="state error" role="alert">
        {error instanceof Error ? error.message : 'Something went wrong.'}
      </div>
    );
  if (empty) return <div className="state">Nothing here yet.</div>;
  return <>{children}</>;
}

export const formatDate = (value: string) =>
  new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(value),
  );
